export const CONTRACT_NEMO_TYPE = "CONT";
export const PARAM_NAME_PW = "SG3PlusBook";

export const PARAM_OBSERVER_ROLE = "754c9716-fcbc-4fac-aed1-62e4fc7e8a01";
export const PARAM_ADMIN_ROLE = "A19028E1-D5A0-4840-B2BC-41CBFC514E1C";
export const PARAM_USER_ROLE = "664aed6e-4b12-4cb5-869d-f5848965bcfc";
export const PARAM_EXTERNAL_ROLE = "90ef7bdd-8b76-4f5c-aa83-2d027dcd74db";
